import * as React from 'react';
import * as ReactDom from 'react-dom';

import { QueryClientProvider } from '@tanstack/react-query';

import { Discover } from '~teacher/components/Discover';
import { queryClient } from '~teacher/queryClient';

export default function renderDiscoverPage() {
  ReactDom.render(<DiscoverPage />, document.getElementById('main-content'));
}

function DiscoverPage() {
  return (
    <QueryClientProvider client={queryClient}>
      <Discover />
    </QueryClientProvider>
  );
}
